import React from 'react';
import { Reveal } from './Reveal';
const bonuses = [{
  title: 'Gids voor de Keeper',
  description: 'Een specifieke gids voor trainers met een keeper in het team',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/a2e696a5-7156-4935-a011-5c85d9863cce.jpg'
}, {
  title: 'Woordflashcards',
  description: 'Versterk elk belangrijk hockeybegrip',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/85dae26c-10b1-4fd8-a51f-f39e4f0922b0.jpg'
}, {
  title: 'Extra Spellenbundel',
  description: 'Houd je trainingen fris en gevarieerd',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/1691862a-bcf0-4002-b0d3-8a559a055555.jpg'
}, {
  title: 'Compleet Seizoensplan',
  description: 'Een volledig invulbare jaarplanning',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/37920940-196d-4aff-98d6-86f50c561397.jpg'
}, {
  title: 'Wedstrijddag- en Toernooipakket',
  description: "Materiaal voor wedstrijddagen, inclusief diploma's",
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/667f40a9-1b65-4348-8d11-357bfeea955d.jpg'
}];
export function BonusesSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-17" data-mp="2k1atcdn6tmn">
      <Reveal className="mx-auto max-w-3xl" data-id="element-18" data-mp="7l8izcjp5utu">
        <div className="mb-12 text-center" data-id="element-19" data-mp="7m0fcpl4bwl6">
          <div className="inline-flex rounded-full bg-brand-moss/15 px-4 py-2 text-[10px] font-extrabold tracking-[0.14em] text-brand-moss" data-id="element-20" data-mp="ckbnmvvrlz1a">
            VANDAAG GRATIS INBEGREPEN
          </div>
          <h2 className="mt-4 text-3xl font-black text-brand-green md:text-4xl" data-id="element-21" data-mp="lcdnot1x9db1">
            🎁 5 Exclusieve Bonussen
          </h2>
          <p className="mt-4 text-brand-gray" data-id="element-22" data-mp="q9vkjl2o022o">
            Volledig gratis inbegrepen bij je aankoop vandaag.
          </p>
        </div>
        <div className="space-y-3" data-id="element-23" data-mp="v86xi4o9asp4">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="flex items-center gap-4 rounded-2xl border border-brand-green/[0.08] bg-brand-alt p-4 shadow-sm sm:gap-5" data-id="element-24" data-mp="109mglr6vip4v" data-mpi={index}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-green font-serif font-bold text-white" data-id="element-25" data-mp="5nz13ssp43v8">
                {index + 1}
              </span>
              <img src={bonus.image} alt={`Omslag van ${bonus.title}`} className="h-20 w-14 shrink-0 rounded-md border border-brand-dark object-cover shadow-sm sm:h-24 sm:w-[4.25rem]" data-id="element-26" data-mp="fir0911xeys4" />
              <div className="min-w-0 flex-1" data-id="element-27" data-mp="139mndkvft5t1">
                <h3 className="font-bold leading-snug text-brand-green" data-id="element-28" data-mp="139e9bpnkvug9">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-xs" data-id="element-29" data-mp="y8qmzhaao1sd">
                  <span className="text-brand-gray" data-id="element-30" data-mp="350hmomourn4i">{bonus.description}</span>
                  <span className="ml-2 font-extrabold text-brand-moss" data-id="element-31" data-mp="302g380nillsi">
                    GRATIS
                  </span>
                </p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}